export default "__VITE_ASSET__JUvv98$z__"